module.exports = __webpack_public_path__ + "static/media/locknox-3.377b1fde.jpg";